import React from "react";

import { Results } from "@app/scripts/reactify/results/Results";
import { setIsKids } from "@app/scripts/utils/tagFilters";

// If the collection name from the URL contains "kids", we set the `isKids` flag to true.
if (window.location.pathname.includes("kids")) {
  setIsKids(true)
}

export const Collection = () => <Results />;
